<script>
import Layout from "../../layouts/main";
import PageHeader from '@/components/page-header-custom.vue';
import appConfig from "@/app.config";
import { layoutMethods, layoutComputed } from "@/state/helpers"

/**
 * Sales-Dashboard component
 */
export default {
  page: {
    title: "Roles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      submitted: false,
      toastTitle: "",
      toastMessage: "",
      toastType: "",
      showToast: false
    };
  },
  components: {
    Layout,
    PageHeader
  },
  computed: {
    ...layoutComputed
  },
  methods: {
    ...layoutMethods,
    openToast(toast) {
      // this.toastType = toast.type;
      // this.toastTitle = toast.title;
      // this.toastMessage = toast.message;
      // this.showToast = true;

      this.$toast.showToast(toast.type, toast.title, toast.message);
    }
  }
};
</script>

<template>
  <Layout >
    <PageHeader :title="title" :items="breadCrumbs" :prev="{name:'',params:{}}" :backButton="showBackButton"/>
    <!-- <b-button variant="primary">Button</b-button> -->
    <router-view @show-toast="openToast"/>
    
    
    <!-- <toast 
      :type="toastType" 
      v-if="showToast" 
      @close="() => showToast = false" 
      :title="toastTitle" 
      :message="toastMessage"/> -->
  </Layout>
</template>